import { Skeleton } from "@/components/ui/skeleton"

/**
 * OKS-392 — Loading skeleton for the community feed (W11). 12 placeholder
 * tiles mirroring the real 3-col grid (square tiles + a faux avatar dot),
 * NOT a spinner (UX Spec §3). The 4th row is clipped exactly like the
 * populated grid so the cross-fade to content has no layout jump.
 *
 * `aria-hidden` + a polite "loading" label so assistive tech announces the
 * load without reading 12 empty tiles.
 */
const PLACEHOLDER_COUNT = 12

export function CommunityFeedSkeleton() {
  return (
    <div
      data-testid="community-feed-skeleton"
      className="relative max-h-[calc(100vw*1.05)] overflow-hidden"
      role="status"
      aria-label="loading"
    >
      <ul className="grid grid-cols-3 gap-2" aria-hidden="true">
        {Array.from({ length: PLACEHOLDER_COUNT }).map((_, index) => (
          <li key={index} className="relative aspect-square">
            <Skeleton className="size-full rounded-lg" />
            <Skeleton className="absolute bottom-1.5 left-1.5 size-6 rounded-full" />
          </li>
        ))}
      </ul>
    </div>
  )
}
